// getAllMaterialTemplateList

import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { MaterialTemplateType } from "../../Types/HeyTraderTypes/Materials/MaterialTemplateType";
import { getAllMaterialTemplateList } from "../../Thunks/HeyTraderThunks";

interface MaterialTemplateSliceState {
    loader: boolean; // for refres pages and inital loadings
    templateList: MaterialTemplateType[];
    errorDisplay: string | null;
}

// set inital valus
const initialState : MaterialTemplateSliceState = {
    loader: false,
    templateList: [],
    errorDisplay: '',

}

// set state valu for api response

const MaterialTemplateSlice = createSlice ({
    name: 'materialTemplate',
    initialState,
    reducers : {
    },
    extraReducers(builder){
        builder.addCase(getAllMaterialTemplateList.rejected, (state, action) => {
                    state.loader = false;
                    state.errorDisplay = action.error.message!;
                  })
                    .addCase(getAllMaterialTemplateList.pending, state => {
                    state.loader = true;
                    state.errorDisplay = null;
                  })
                  .addCase(getAllMaterialTemplateList.fulfilled, (state, action: PayloadAction<MaterialTemplateType[]>) => {
                    state.loader = false;
                    state.templateList = action.payload;
                  })
    }
})

export const {} = MaterialTemplateSlice.actions
export default MaterialTemplateSlice.reducer

